import portfolio from './portfolio.png'
import ytclone from './ytclone.png'
import speedtype from './speedtype.png'

const projectsArr = [
  {
    id: 1,
    img: portfolio,
    title: 'Personal Portfolio',
    sourcecode: 'https://github.com/kishoreanandv/portfolio',
    demo: 'https://kishoreanandv.github.io/portfolio',
    languageOne: '#ReactJs',
    languageTwo: '#JavaScript',
    languageThree: '#scss',
  },
  {
    id: 2,
    img: ytclone,
    title: 'Youtube Clone-React',
    sourcecode: 'https://github.com/kishoreanandv/youtube-clone-react',
    demo: 'https://zingy-blancmange-18604a.netlify.app/',
    languageOne: '#ReactJs',
    languageTwo: '#JavaScript',
    languageThree: '#materialUi',
  },
  {
    id: 3,
    img: speedtype,
    title: 'Speed Type',
    sourcecode: 'https://github.com/kishoreanandv/Speed-Typing-Javascript',
    demo: 'https://kishoreanandv.github.io/Speed-Typing-Javascript/',
    languageOne: '#JavaScript',
    languageTwo: '#css',
    languageThree: '#html',
  },
]

export default projectsArr
